import * as Thumbnails from "../../../assets/img/widgets/workspaceWidgetThumbnails";

export const defaultIconSiteId = 176; // Klara

export const defaultIconStyling = {
  borderColor: "#888",
  borderRadius: "8px",
  borderWidth: "2px",
  boxShadow: "2.57px 3.06px 5px rgba(0, 0, 0, 0.1)",
};

export const mapSiteToThumbnail = (siteId) => (siteToThumbnailMapping[siteId]);

const siteToThumbnailMapping = {
  18: Thumbnails.Mediabank,
  176: Thumbnails.Klara,
  177: Thumbnails.Imagebank,
  206: Thumbnails.Siv,
  949: Thumbnails.Project,
};
